function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M99.9997 97.2846C99.9962 98.193 99.9609 99.0983 99.8945 99.9997H0.102021C0.0387689 99.0983 0.00379058 98.193 0.000292751 97.2846C-0.0699553 78.9244 12.5079 61.3462 31.5857 53.5586C36.4885 58.1014 43.0583 60.8762 50.2702 60.8762C57.4821 60.8762 63.9115 58.1576 68.8002 53.7025C87.6603 61.5988 100.073 79.061 99.9997 97.2846Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5367 54.9917C65.7292 54.9917 78.0451 42.6814 78.0451 27.4959C78.0451 12.3103 65.7292 0 50.5367 0C35.3442 0 23.0283 12.3103 23.0283 27.4959C23.0283 42.6814 35.3442 54.9917 50.5367 54.9917Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.12 58.68C105.853 58.68 105.627 58.5867 105.44 58.4C105.253 58.2133 105.16 57.9867 105.16 57.72V49.92H97.48C97.2133 49.92 96.9867 49.8267 96.8 49.64C96.6133 49.4533 96.52 49.2267 96.52 48.96V46.84C96.52 46.5467 96.6133 46.32 96.8 46.16C96.9867 45.9733 97.2133 45.88 97.48 45.88H105.16V38.28C105.16 38.0133 105.253 37.7867 105.44 37.6C105.627 37.4133 105.853 37.32 106.12 37.32H108.44C108.733 37.32 108.96 37.4133 109.12 37.6C109.307 37.7867 109.4 38.0133 109.4 38.28V45.88H117.08C117.347 45.88 117.573 45.9733 117.76 46.16C117.947 46.32 118.04 46.5467 118.04 46.84V48.96C118.04 49.2267 117.947 49.4533 117.76 49.64C117.573 49.8267 117.347 49.92 117.08 49.92H109.4V57.72C109.4 57.9867 109.307 58.2133 109.12 58.4C108.96 58.5867 108.733 58.68 108.44 58.68H106.12Z",
  fill: "white"
});

var SvgUserPlus = function SvgUserPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 70,
    viewBox: "0 0 119 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-plus.5dd21c02.svg";
export { ForwardRef as ReactComponent };